import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { ChipAutocompleteComponent } from './components/chip-autocomplete/chip-autocomplete.component';
import { ChipAutocompleteFormDirective } from './directives/chip-autocomplete-form.directive';
import { FilterDirective } from './directives/filter.directive';
import { HintIconComponent } from '../hint-icon/hint-icon.component';

@NgModule({
    declarations: [ChipAutocompleteFormDirective, ChipAutocompleteComponent, FilterDirective],
  imports: [CommonModule, MatChipsModule, MatFormFieldModule, FontAwesomeModule, ReactiveFormsModule, MatAutocompleteModule, MatTooltipModule, MatLegacyButtonModule, AppButtonModule, HintIconComponent],
    exports: [ChipAutocompleteFormDirective, ChipAutocompleteComponent, FilterDirective],
})
export class CustomFormsModule {}
